// @flow
import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useGetSPUserCommitSFDCViewQuery } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { DataFetcherContainer } from '@presentational/DataFetcherContainer';
import { shouldSkipDataFetching } from '@src/common-utils/utils';

import { SPUserCommitSFDCFieldsViewsContainer } from './SPUserCommitSFDCFieldsViewsContainer';

export const SPUserCommitSFDCFieldsViewsContainerWrapper = () => {
  const params = useParams();

  const dataFetchingArgs = useMemo(
    () => [
      { ...params },
      {
        refetchOnMountOrArgChange: true,
        skip: shouldSkipDataFetching(params),
      },
    ],
    [params]
  );

  const dataFetchingFunction = useCallback(useGetSPUserCommitSFDCViewQuery, []);

  return (
    <DataFetcherContainer
      dataFetchingArgs={dataFetchingArgs}
      dataFetchingFunction={dataFetchingFunction}
    >
      {(data) => {
        return <SPUserCommitSFDCFieldsViewsContainer data={data} />;
      }}
    </DataFetcherContainer>
  );
};
